import { Routes } from '@angular/router';

export const COUNTRY_ROUTES: Routes = [
  {
    path: 'channels/countries/view-edit/:countryId',
    loadComponent: () =>
      import('./country-view-edit/country-view-edit.component').then(
        (com) => com.CountryViewEditComponent
      ),
    title: 'View/Edit Country',
  },
  {
    path: 'channels/countries/add',
    loadComponent: () =>
      import('./country-add/country-add.component').then(
        (com) => com.CountryAddComponent
      ),
    title: 'Add Country',
  },
];
